// extracted by mini-css-extract-plugin
module.exports =  {"common-report":"daemonDownload__common-report","bottom-popup":"daemonDownload__bottom-popup","bottom-popup-text":"daemonDownload__bottom-popup-text"};